module.exports = __webpack_public_path__ + "img/biaoqian.f4965c5e.jpg";